// Geometria pura para "abrir" markers com coordenadas coincidentes em
// círculo ao redor do centro. Sem dependência de OpenLayers — recebe/devolve
// arrays [x, y] simples para ser testável sem mocks.

// ponytail: layout em círculo único; se algum dia precisar de grade para
// clusters muito grandes (>~12), trocar aqui.
export const isCoincident = (coordinates, epsilon = 1) => {
  if (coordinates.length < 2) return false;
  const [x0, y0] = coordinates[0];
  return coordinates.every(([x, y]) => Math.hypot(x - x0, y - y0) <= epsilon);
};

export const spiderfyCoordinates = (coordinates, radius) => {
  const count = coordinates.length;
  if (count <= 1) return coordinates;

  const [cx, cy] = coordinates[0];
  const step = (2 * Math.PI) / count;

  return coordinates.map((_, i) => {
    const angle = i * step;
    return [cx + radius * Math.cos(angle), cy + radius * Math.sin(angle)];
  });
};
